import { InputAdornment } from "@mui/material";
import lockicon from "../../../../images/lockIcon.png";
import { useState } from "react";

export default function FormLeagues(values) {
    // Get current year as default value
    const currentYear = new Date().getFullYear();
    
    return [
      {
        shape: "div",
        type: "wrapper",
        className: "",
        sx: {
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gridColumnGap: "100px",
        },
        children: [
            {
                shape: "input",
                type: "select",
                name: "league",
                // handleChange: handleChange,
                className: "border",
                title: "League",
                label: "League",
                options: values.leagues,
                placeholder: "",
                width: "100%",
                validation: {
                  required: true,
                },
              },
            {
            shape: "input",
            type: "select",
            name: "season_year",
            // handleChange: handleChange,
            className: "border",
            title: "Season",
            label: "Season",
            options: values.seassionYear,
            placeholder: currentYear.toString(), // Show current year as placeholder
            defaultValue: currentYear, // Set current year as default
            width: "100%", 
            validation: {
              required: true,
            },
          }
        ],
      },
      {
        shape: "div",
        type: "wrapper",
        className: "",
        sx: {
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gridColumnGap: "100px",
        },
        children: [
          {
            shape: "input",
            type: "text",
            name: "name",
            // handleChange: handleChange,
            className: "border",
            title: "League Season Display Name",
            label: "League Season Display Name",
            placeholder: "Enter Match week name",
            width: "100%",
            validation: {
              required: true,
            },
          },
        ],
      },
      {
        shape: "div",
        type: "wrapper",
        className: "",
        sx: { display: "flex", justifyContents: "flex-start", mt: 6 },
        children: [
          {
            shape: "button",
            type: "action",
            title: 'Fetch Details',
            // submitButton : true,
            isDisabled: !values.isSystemLeagueSelected,
            name: "Add",
            sx : {mr:2,
             },
            validation: {
              hiddenRules: [
                {
                  mode: "view",
                },
              ],
             
            },
          },        
        ],
      },
    
    ];
  }